import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b245a3bc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b245a3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b245a3bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b245a3bc')) {
      api.createRecord('b245a3bc', component.options)
    } else {
      api.reload('b245a3bc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b245a3bc&scoped=true&", function () {
      api.rerender('b245a3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25sdy7AQ8rsNt/JS/comp/SearchFilterTokens.vue"
export default component.exports